import {
  GET_COURSE_PAGE_EVAL_STATUS_URL,
  GET_SUBJECT_PAGE_EVAL_STATUS_URL,
  GET_TOPIC_PAGE_EVAL_STATUS_URL,
  GET_SUBTOPIC_PAGE_EVAL_STATUS_URL,
  CREATE_COURSE_EVAL_PAGE_CONTENT_URL,
  CREATE_SUBJECT_EVAL_PAGE_CONTENT_URL,
  CREATE_TOPIC_EVAL_PAGE_CONTENT_URL,
  CREATE_SUBTOPIC_EVAL_PAGE_CONTENT_URL,
  GET_COURSE_EVAL_PAGE_CONTENT_URL,
  GET_SUBJECT_EVAL_PAGE_CONTENT_URL,
  GET_TOPIC_EVAL_PAGE_CONTENT_URL,
  GET_SUBTOPIC_EVAL_PAGE_CONTENT_URL,
  EVAL_WITH_AI_URL,
} from "../apiurls/apiurls";
import Cookies from "js-cookie";

const getAuthToken = () => {
  const role = Cookies.get("role");
  if (role === "institution" || role === "teacher") {
    return Cookies.get("institution_token");
  }
  return Cookies.get("admin_token");
};

export const createCourseEvalManually = async ({ key, pageId, evalution_score }) => {
  try {
    const response = await fetch(CREATE_COURSE_EVAL_PAGE_CONTENT_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({
        key,
        course_page_content: pageId,
        evalution_score,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating course eval manually:", error);
    throw error;
  }
};

export const createSubjectEvalManually = async ({ key, pageId, evalution_score }) => {
  try {
    const response = await fetch(CREATE_SUBJECT_EVAL_PAGE_CONTENT_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({
        key,
        subject_page_content: pageId,
        evalution_score,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating subject eval manually:", error);
    throw error;
  }
};

export const createTopicEvalManually = async ({ key, pageId, evalution_score }) => {
  try {
    const response = await fetch(CREATE_TOPIC_EVAL_PAGE_CONTENT_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({
        key,
        topic_page_content: pageId,
        evalution_score,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating topic eval manually:", error);
    throw error;
  }
};

export const createSubtopicEvalManually = async ({
  key,
  pageId,
  evalution_score,
}) => {
  try {
    const response = await fetch(CREATE_SUBTOPIC_EVAL_PAGE_CONTENT_URL, {
      method: "POST",
      headers: getHeaders(),
      body: JSON.stringify({
        key,
        subtopic_page_content: pageId,
        evalution_score,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error creating subtopic eval manually:", error);
    throw error;
  }
};

const getHeaders = (includeContentType = true) => {
  const headers = {};
  if (includeContentType) {
    headers["Content-Type"] = "application/json";
  }
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

const normalizeEvalStatusResponse = (response) => {
  const result = {
    summary: {
      evaluated_pages: response?.evaluated_pages ?? 0,
      total_pages: response?.total_pages ?? 0,
    },
    byPageId: {
      "default-page": { evaluated: true, overall_score: null, evaluated_id: null },
    },
  };

  const items = Array.isArray(response?.data) ? response.data : [];

  items.forEach((item) => {
    if (item && item.page) {
      result.byPageId[item.page] = {
        evaluated: !!item.evaluated,
        overall_score: item.overall_score ?? null,
        evaluated_id:
          item.evaluated_id ??
          item.evaluatedId ??
          item.evaluation_id ??
          item.evaluationId ??
          null,
      };
    }

    if (Array.isArray(item?.child_pages)) {
      item.child_pages.forEach((child) => {
        if (child && child.page) {
          result.byPageId[child.page] = {
            evaluated: !!child.evaluated,
            overall_score: child.overall_score ?? null,
            evaluated_id:
              child.evaluated_id ??
              child.evaluatedId ??
              child.evaluation_id ??
              child.evaluationId ??
              null,
          };
        }
      });
    }
  });

  return result;
};

export const getCoursePageEvalStatus = async (courseKey) => {
  try {
    const url = `${GET_COURSE_PAGE_EVAL_STATUS_URL}?key=${encodeURIComponent(
      courseKey,
    )}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return normalizeEvalStatusResponse(data);
  } catch (error) {
    console.error("Error fetching eval status for course pages:", error);
    throw error;
  }
};

export const evalWithAiMark = async ({ title, key, pageId, level }) => {
  try {
    let url = `${EVAL_WITH_AI_URL}?title=${encodeURIComponent(
      title,
    )}&key=${encodeURIComponent(key)}&page_id=${encodeURIComponent(pageId)}`;
    if (level) {
      url += `&level=${encodeURIComponent(level)}`;
    }

    const response = await fetch(url, {
      method: "POST",
      headers: getHeaders(false),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error marking eval with AI:", error);
    throw error;
  }
};

export const getSubjectPageEvalStatus = async (subjectKey) => {
  try {
    const url = `${GET_SUBJECT_PAGE_EVAL_STATUS_URL}?key=${encodeURIComponent(
      subjectKey,
    )}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return normalizeEvalStatusResponse(data);
  } catch (error) {
    console.error("Error fetching eval status for subject pages:", error);
    throw error;
  }
};

export const getTopicPageEvalStatus = async (topicKey) => {
  try {
    const url = `${GET_TOPIC_PAGE_EVAL_STATUS_URL}?key=${encodeURIComponent(
      topicKey,
    )}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return normalizeEvalStatusResponse(data);
  } catch (error) {
    console.error("Error fetching eval status for topic pages:", error);
    throw error;
  }
};

export const getSubtopicPageEvalStatus = async (subtopicKey) => {
  try {
    const url = `${GET_SUBTOPIC_PAGE_EVAL_STATUS_URL}?key=${encodeURIComponent(
      subtopicKey,
    )}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    return normalizeEvalStatusResponse(data);
  } catch (error) {
    console.error("Error fetching eval status for subtopic pages:", error);
    throw error;
  }
};

export const getCourseEvalPageContent = async (pageId) => {
  try {
    const url = `${GET_COURSE_EVAL_PAGE_CONTENT_URL}?id=${encodeURIComponent(pageId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching eval content for course page:", error);
    throw error;
  }
};

export const getSubjectEvalPageContent = async (pageId) => {
  try {
    const url = `${GET_SUBJECT_EVAL_PAGE_CONTENT_URL}?id=${encodeURIComponent(pageId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching eval content for subject page:", error);
    throw error;
  }
};

export const getTopicEvalPageContent = async (pageId) => {
  try {
    const url = `${GET_TOPIC_EVAL_PAGE_CONTENT_URL}?id=${encodeURIComponent(pageId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching eval content for topic page:", error);
    throw error;
  }
};

export const getSubtopicEvalPageContent = async (pageId) => {
  try {
    const url = `${GET_SUBTOPIC_EVAL_PAGE_CONTENT_URL}?id=${encodeURIComponent(pageId)}`;
    const response = await fetch(url, {
      method: "GET",
      headers: getHeaders(),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error("Error fetching eval content for subtopic page:", error);
    throw error;
  }
};

